
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import vSelect from "vue-select"

@Component({
	components: {
		"v-select": vSelect
	}
})
export default class Label extends Vue {
@Prop()
value: any;

@Prop()
edit!: boolean

text: string = "";
fontSize: string = "md"

sizes: any[] = [
	{
		size: "Medium",
		code: "md"
	},
	{
		size: "Large",
		code: "lg"
	},
	{
		size: "Extra Large",
		code: "xl"
	}
]

mounted () {
	if (this.value) {
		this.text = this.value.text
		this.fontSize = this.value.size ? this.value.size : "md"
	}
}

@Watch("size")
private sizeChanged (size: string) {
	let value = {
		text: this.text,
		size: size
	}
	this.$emit("input", value)
}

@Watch("text")
private textChanged (text: string) {
	let value = {
		text: text,
		size: this.fontSize
	}
	this.$emit("input", value)
}

mouseDown () {
}

mouseMove () {
}
}
